export default __webpack_public_path__ + "static/media/masdrLogo.ee795a5f.svg";